const Map = () => (
    <iframe
        className="w-100 h-100 border-0"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3634.4321469857605!2d54.48479857513537!3d24.36626577825525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e4121145132a7%3A0xf03991126521d3a3!2sLogic%20Fusion%20LLC!5e0!3m2!1sen!2sin!4v1715687032004!5m2!1sen!2sin"
        allowFullScreen
        style={{ filter: ' invert(100%)  hue-rotate(200deg)' }}
    />
);

export default Map;